import React, { useState, useEffect } from "react";
import { Row, Col, Breadcrumb } from "antd";
import { Link, useLocation } from "react-router-dom";
import { Link as LinkScroll, Element } from "react-scroll";
import CountUp from "react-countup";

import ScrollUpBtn from "components/ScrollUpBtn";
import DetailContact from "components/DetailContact";

import { breadcrumbName } from "core/util/common";
import { httpClient } from "core/util/httpClient";
import { institute, contract } from "core/schemas";

import sci from "assets/images/png/01-Sci.png";
import soctech from "assets/images/png/02-Soctech.png";
import agri from "assets/images/png/03-Agri.png";
import engi from "assets/images/png/04-Engi.png";
import med from "assets/images/png/05-Med.png";
import nurs from "assets/images/png/06-Nurs.png";
import dent from "assets/images/png/07-Dent.png";
import pubH from "assets/images/png/08-PubH.png";
import digiT from "assets/images/png/09-DigiT.png";
import stuView from "assets/images/png/student_comp-01.png";

import {
  Container,
  CusttomBreadcrumb,
  Title,
  TitleEN,
  TextSection,
  TextTitle,
  ListImage,
  TextDetail,
  BoxImage,
  CustomCarousel,
  FixBoxLayout,
  CardContact,
  View,
  SubHead,
} from "./courseInfoBranch.style";

const CourseInfoBranch = () => {
  const [dataBranch, setDataBranch] = useState([]);
  const [slang, setSlang] = useState("");
  const [contactData, setContactData] = useState([]);

  const { pathname } = useLocation();
  const splitPath = pathname.split("/") || [];
  splitPath.shift();

  useEffect(() => {
    window.scrollTo(0, 0);

    getDataBranch();
  }, []);

  const getDataBranch = async () => {
    const response = await httpClient.get(
      `${institute}/branch?branch=${splitPath[2]}`
    );

    if (response?.data?.code === 200) {
      const data = response?.data?.data;

      setDataBranch(data);
      setSlang(data?.information?.slang);
      getDataContact(data?.information?.courseID);
    } else {
      setDataBranch([]);
    }
  };

  const getDataContact = async (id) => {
    const response = await httpClient.get(`${contract}?course=${id && id}`);

    if (response?.data?.code === 200) {
      const data = response?.data?.data;

      setContactData(data);
    } else {
      setContactData([]);
    }
  };

  const newPath = (route) => {
    let path = "";
    const orderRoute = splitPath.indexOf(route);
    splitPath.map((item, i) => i <= orderRoute && (path += `/${item}`));

    return path;
  };

  const styleDetailContact = { marginBottom: "30px" };

  const renderLink = (to, name) => {
    return (
      <LinkScroll
        activeClass="active"
        to={to}
        spy={true}
        smooth={true}
        duration={500}
        offset={-130}
      >
        <TextSection>{name}</TextSection>
      </LinkScroll>
    );
  };

  const ListColor1 = {
    physics: "#FFE346",
    chemical: "#FFE346",
    "sports-science": "#FFE346",
    mathematics: "#FFE346",
    "geographical-informatics": "#FFE346",
    biology: "#FFE346",
    micorbiology: "#FFE346",
    "medical-sciences": "#FFE346",
    "computer-science": "#FFE346",
    "management-tectnology": "#1f66b0",
    "management-tectnology-innovation": "#1f66b0",
    "crop-production-technology": "#5abc73",
    "technology-program-in-innovative-agripreneur": "#5abc73",
    "animal-technology-and-innovation": "#5abc73",
    "food-technology": "#5abc73",
    "manufacturing-automation-and-robotics-engineering": "#81000f",
    "agricultural-and-food-engineering": "#81000f",
    "transportation-and-logistics-engineering": "#81000f",
    "ceramic-engineering": "#81000f",
    "telecommunication-engineering": "#81000f",
    "polymer-engineering": "#81000f",
    "polymer-engineering-inter": "#81000f",
    "electrical-engineering": "#81000f",
    "civil-engineering": "#81000f",
    "metallurgical-engineering": "#81000f",
    "environmental-engineering": "#81000f",
    "industrial-engineering": "#81000f",
    "geological-engineering": "#81000f",
    "geological-engineering-petro": "#81000f",
    "electronic-engineering": "#81000f",
    "computer-engineering": "#81000f",
    "chemical-engineering": "#81000f",
    "mechanical-engineering": "#81000f",
    "material-innovation-and-design-engineering": "#81000f",
    "precision-engineering": "#81000f",
    "mechatronics-engineering": "#81000f",
    "automotive-and-aeronautical-engineering": "#81000f",
    "civil-engineering-inter": "#81000f",
    "civil-and-infrastructure-engineering": "#81000f",
    "intelligent-embedded-engineering": "#81000f",
    "industrial-electrical-engineering": "#81000f",
    "electronics-and-embedded-system-egineering": "#81000f",
    "automotive-engineering": "#81000f",
    "mechanical-and-aeronautical-engineering": "#81000f",
    medicine: "#176543",
    "nursing-science": "#313778",
    "department-dentistry": "#774f9f",
    "doctor-of-dental-surgery": "#774f9f",
    "environmental-health": "#ee579b",
    "occupational-health-and-safety": "#ee579b",
    "nutrition-and-dietetics": "#ee579b",
    "digital-technology": "#8fefc1",
    "digital-communication": "#8fefc1",
    "nursing-science-60": "#313778",
    "nursing-science-65": "#313778",
  };

  const ListColor2 = {
    micorbiology: "#FFFAE6",
    "medical-sciences": "#FFFAE6",
    "computer-science": "#FFFAE6",
    physics: "#FFFAE6",
    chemical: "#FFFAE6",
    "sports-science": "#FFFAE6",
    mathematics: "#FFFAE6",
    "geographical-informatics": "#FFFAE6",
    biology: "#FFFAE6",
    "management-tectnology": "#edf1f6",
    "management-tectnology-innovation": "#edf1f6",
    "crop-production-technology": "#fff3f8",
    "technology-program-in-innovative-agripreneur": "#fff3f8",
    "animal-technology-and-innovation": "#fff3f8",
    "food-technology": "#fff3f8",
    "manufacturing-automation-and-robotics-engineering": "#fafbfb",
    "agricultural-and-food-engineering": "#fafbfb",
    "transportation-and-logistics-engineering": "#fafbfb",
    "ceramic-engineering": "#fafbfb",
    "telecommunication-engineering": "#fafbfb",
    "polymer-engineering": "#fafbfb",
    "polymer-engineering-inter": "#fafbfb",
    "electrical-engineering": "#fafbfb",
    "civil-engineering": "#fafbfb",
    "metallurgical-engineering": "#fafbfb",
    "environmental-engineering": "#fafbfb",
    "industrial-engineering": "#fafbfb",
    "geological-engineering": "#fafbfb",
    "geological-engineering-petro": "#fafbfb",
    "electronic-engineering": "#fafbfb",
    "computer-engineering": "#fafbfb",
    "chemical-engineering": "#fafbfb",
    "mechanical-engineering": "#fafbfb",
    "material-innovation-and-design-engineering": "#fafbfb",
    "precision-engineering": "#fafbfb",
    "mechatronics-engineering": "#fafbfb",
    "automotive-and-aeronautical-engineering": "#fafbfb",
    "automotive-engineering": "#fafbfb",
    "industrial-electrical-engineering": "#fafbfb",
    "electronics-and-embedded-system-egineering": "#fafbfb",
    "intelligent-embedded-engineering": "#fafbfb",
    "civil-and-infrastructure-engineering": "#fafbfb",
    "civil-engineering-inter": "#fafbfb",
    "mechanical-and-aeronautical-engineering": "#fafbfb",
    medicine: "#f0f7ed",
    "nursing-science": "#f2f3f8",
    "department-dentistry": "#fdfcfa",
    "doctor-of-dental-surgery": "#fdfcfa",
    "environmental-health": "#FEF3F8",
    "occupational-health-and-safety": "#FEF3F8",
    "nutrition-and-dietetics": "#FEF3F8",
    "digital-technology": "#ecf5f8",
    "digital-communication": "#ecf5f8",
    "nursing-science-60": "#f2f3f8",
    "nursing-science-65": "#f2f3f8",
  };

  const renderLinkName = {
    "เป้าหมายการได้งานทำ ของบัณฑิต": dataBranch?.information?.employment_goals,
    โครงสร้างหลักสูตร: dataBranch?.information?.course_structure,
    แผนการศึกษา: dataBranch?.information?.study_plan,
    อาจารย์ประจำหลักสูตร: dataBranch?.information?.teacher,
    "เป้าหมายการรับและ การสำเร็จการศึกษา":
      dataBranch?.information?.graduation_goals,
    "ผลการรับและ สำเร็จการศึกษา": dataBranch?.information?.graduation_results,
  };

  const LinkBranch = (detail) => {
    const branch = dataBranch && dataBranch?.information;
    let showLink = false;

    if (
      detail === "เป้าหมายการได้งานทำ ของบัณฑิต" &&
      branch?.employment_goals !== "รอข้อมูลจากสำนัก"
    ) {
      showLink = true;
    } else if (
      detail === "โครงสร้างหลักสูตร" &&
      branch?.course_structure !== "รอข้อมูลจากสำนัก"
    ) {
      showLink = true;
    } else if (
      detail === "แผนการศึกษา" &&
      branch?.study_plan !== "รอข้อมูลจากสำนัก"
    ) {
      showLink = true;
    } else if (
      detail === "อาจารย์ประจำหลักสูตร" &&
      branch?.teacher !== "รอข้อมูลจากสำนัก"
    ) {
      showLink = true;
    } else if (
      detail === "เป้าหมายการรับและ การสำเร็จการศึกษา" &&
      branch?.graduation_goals !== "รอข้อมูลจากสำนัก"
    ) {
      showLink = true;
    } else if (
      detail === "ผลการรับและ สำเร็จการศึกษา" &&
      branch?.graduation_results !== "รอข้อมูลจากสำนัก"
    ) {
      showLink = true;
    } else {
      showLink = false;
    }

    return (
      showLink && (
        <a
          href={renderLinkName[detail]}
          target="_blank"
          rel="noreferrer"
          download
        >
          <div
            style={{
              width: "100%",
              display: "flex",
              justifyContent: "center",
            }}
          >
            <p>อ่านเพิ่มเติม</p>
          </div>
        </a>
      )
    );
  };

  const runderElement = {
    "เป้าหมายการได้งานทำ ของบัณฑิต": "employment-goals",
    โครงสร้างหลักสูตร: "course-structure",
    แผนการศึกษา: "study-plan",
    อาจารย์ประจำหลักสูตร: "course-teacher",
    "เป้าหมายการรับและ การสำเร็จการศึกษา": "graduation-goals",
    "ผลการรับและ สำเร็จการศึกษา": "graduation-results",
  };

  const ListContact = {
    micorbiology: "ข้อมูลติดต่อหลักสูตร/หน่วยงาน ภายในสำนักวิชาวิทยาศาสตร์",
    "medical-sciences":
      "ข้อมูลติดต่อหลักสูตร/หน่วยงาน ภายในสำนักวิชาวิทยาศาสตร์",
    "computer-science":
      "ข้อมูลติดต่อหลักสูตร/หน่วยงาน ภายในสำนักวิชาวิทยาศาสตร์",
    physics: "ข้อมูลติดต่อหลักสูตร/หน่วยงาน ภายในสำนักวิชาวิทยาศาสตร์",
    chemical: "ข้อมูลติดต่อหลักสูตร/หน่วยงาน ภายในสำนักวิชาวิทยาศาสตร์",
    "sports-science": "ข้อมูลติดต่อหลักสูตร/หน่วยงาน ภายในสำนักวิชาวิทยาศาสตร์",
    mathematics: "ข้อมูลติดต่อหลักสูตร/หน่วยงาน ภายในสำนักวิชาวิทยาศาสตร์",
    "geographical-informatics":
      "ข้อมูลติดต่อหลักสูตร/หน่วยงาน ภายในสำนักวิชาวิทยาศาสตร์",
    biology: "ข้อมูลติดต่อหลักสูตร/หน่วยงาน ภายในสำนักวิชาวิทยาศาสตร์",
    "management-tectnology": "ข้อมูลติดต่อหน่วยงานภายในสำนักวิชาเทคโนโลยีสังคม",
    "management-tectnology-innovation":
      "ข้อมูลติดต่อหน่วยงานภายในสำนักวิชาเทคโนโลยีสังคม",
    "crop-production-technology":
      "ข้อมูลติดต่อหน่วยงานภายในสำนักวิชาเทคโนโลยีการเกษตร",
    "animal-technology-and-innovation":
      "ข้อมูลติดต่อหน่วยงานภายในสำนักวิชาเทคโนโลยีการเกษตร",
    "food-technology": "ข้อมูลติดต่อหน่วยงานภายในสำนักวิชาเทคโนโลยีการเกษตร",
    "manufacturing-automation-and-robotics-engineering":
      "ข้อมูลติดต่อหน่วยงานภายในสำนักวิชาวิศวกรรมศาสตร์",
    "agricultural-and-food-engineering":
      "ข้อมูลติดต่อหน่วยงานภายในสำนักวิชาวิศวกรรมศาสตร์",
    "transportation-and-logistics-engineering":
      "ข้อมูลติดต่อหน่วยงานภายในสำนักวิชาวิศวกรรมศาสตร์",
    "ceramic-engineering": "ข้อมูลติดต่อหน่วยงานภายในสำนักวิชาวิศวกรรมศาสตร์",
    "telecommunication-engineering":
      "ข้อมูลติดต่อหน่วยงานภายในสำนักวิชาวิศวกรรมศาสตร์",
    "polymer-engineering": "ข้อมูลติดต่อหน่วยงานภายในสำนักวิชาวิศวกรรมศาสตร์",
    "polymer-engineering-inter":
      "ข้อมูลติดต่อหน่วยงานภายในสำนักวิชาวิศวกรรมศาสตร์",
    "electrical-engineering":
      "ข้อมูลติดต่อหน่วยงานภายในสำนักวิชาวิศวกรรมศาสตร์",
    "civil-engineering": "ข้อมูลติดต่อหน่วยงานภายในสำนักวิชาวิศวกรรมศาสตร์",
    "metallurgical-engineering":
      "ข้อมูลติดต่อหน่วยงานภายในสำนักวิชาวิศวกรรมศาสตร์",
    "environmental-engineering":
      "ข้อมูลติดต่อหน่วยงานภายในสำนักวิชาวิศวกรรมศาสตร์",
    "industrial-engineering":
      "ข้อมูลติดต่อหน่วยงานภายในสำนักวิชาวิศวกรรมศาสตร์",
    "geological-engineering":
      "ข้อมูลติดต่อหน่วยงานภายในสำนักวิชาวิศวกรรมศาสตร์",
    "geological-engineering-petro":
      "ข้อมูลติดต่อหน่วยงานภายในสำนักวิชาวิศวกรรมศาสตร์",
    "electronic-engineering":
      "ข้อมูลติดต่อหน่วยงานภายในสำนักวิชาวิศวกรรมศาสตร์",
    "computer-engineering": "ข้อมูลติดต่อหน่วยงานภายในสำนักวิชาวิศวกรรมศาสตร์",
    "chemical-engineering": "ข้อมูลติดต่อหน่วยงานภายในสำนักวิชาวิศวกรรมศาสตร์",
    "mechanical-engineering":
      "ข้อมูลติดต่อหน่วยงานภายในสำนักวิชาวิศวกรรมศาสตร์",
    "material-innovation-and-design-engineering":
      "ข้อมูลติดต่อหน่วยงานภายในสำนักวิชาวิศวกรรมศาสตร์",
    "automotive-and-aeronautical-engineering":
      "ข้อมูลติดต่อหน่วยงานภายในสำนักวิชาวิศวกรรมศาสตร์",
    "civil-engineering-inter":
      "ข้อมูลติดต่อหน่วยงานภายในสำนักวิชาวิศวกรรมศาสตร์",
    "civil-and-infrastructure-engineering":
      "ข้อมูลติดต่อหน่วยงานภายในสำนักวิชาวิศวกรรมศาสตร์",
    "intelligent-embedded-engineering":
      "ข้อมูลติดต่อหน่วยงานภายในสำนักวิชาวิศวกรรมศาสตร์",
    "industrial-electrical-engineering":
      "ข้อมูลติดต่อหน่วยงานภายในสำนักวิชาวิศวกรรมศาสตร์",
    "electronics-and-embedded-system-egineering":
      "ข้อมูลติดต่อหน่วยงานภายในสำนักวิชาวิศวกรรมศาสตร์",
    medicine: "ข้อมูลติดต่อหน่วยงานภายในสำนักวิชาแพทยศาสตร์",
    "nursing-science": "ข้อมูลติดต่อหน่วยงานภายในสำนักวิชาพยาบาลศาสตร์",
    "department-dentistry": "ข้อมูลติดต่อหน่วยงานภายในสำนักวิชาทันตแพทยศาสตร์",
    "environmental-health": "ข้อมูลติดต่อหน่วยงานภายในสำนักวิชาสาธารณสุขศาสตร์",
    "occupational-health-and-safety":
      "ข้อมูลติดต่อหน่วยงานภายในสำนักวิชาสาธารณสุขศาสตร์",
    "digital-technology":
      "ข้อมูลติดต่อหน่วยงานภายในสำนักวิชาศาสตร์และศิลป์ดิจิทัล",
    "digital-communication":
      "ข้อมูลติดต่อหน่วยงานภายในสำนักวิชาศาสตร์และศิลป์ดิจิทัล",
    "technology-program-in-innovative-agripreneur":
      "ข้อมูลติดต่อหน่วยงานภายในสำนักวิชาเทคโนโลยีการเกษตร",
    "nutrition-and-dietetics":
      "ข้อมูลติดต่อหน่วยงานภายในสำนักวิชาสาธารณสุขศาสตร์",
    "nursing-science-60": "ข้อมูลติดต่อหน่วยงานภายในสำนักวิชาพยาบาลศาสตร์",
    "nursing-science-65": "ข้อมูลติดต่อหน่วยงานภายในสำนักวิชาพยาบาลศาสตร์",
    "precision-engineering": "ข้อมูลติดต่อหน่วยงานภายในสำนักวิชาวิศวกรรมศาสตร์",
    "mechatronics-engineering":
      "ข้อมูลติดต่อหน่วยงานภายในสำนักวิชาวิศวกรรมศาสตร์",
    "automotive-engineering":
      "ข้อมูลติดต่อหน่วยงานภายในสำนักวิชาวิศวกรรมศาสตร์",
    "mechanical-and-aeronautical-engineering":
      "ข้อมูลติดต่อหน่วยงานภายในสำนักวิชาวิศวกรรมศาสตร์",
    "doctor-of-dental-surgery":
      "ข้อมูลติดต่อหน่วยงานภายในสำนักวิชาทันตแพทยศาสตร์",
  };

  const ListView = {
    micorbiology: "คู่มือสำนักวิชาวิทยาศาสตร์มีคนเข้ามาดูแล้ว",
    "medical-sciences": "คู่มือสำนักวิชาวิทยาศาสตร์มีคนเข้ามาดูแล้ว",
    "computer-science": "คู่มือสำนักวิชาวิทยาศาสตร์มีคนเข้ามาดูแล้ว",
    physics: "คู่มือสำนักวิชาวิทยาศาสตร์มีคนเข้ามาดูแล้ว",
    chemical: "คู่มือสำนักวิชาวิทยาศาสตร์มีคนเข้ามาดูแล้ว",
    "sports-science": "คู่มือสำนักวิชาวิทยาศาสตร์มีคนเข้ามาดูแล้ว",
    mathematics: "คู่มือสำนักวิชาวิทยาศาสตร์มีคนเข้ามาดูแล้ว",
    "geographical-informatics": "คู่มือสำนักวิชาวิทยาศาสตร์มีคนเข้ามาดูแล้ว",
    biology: "คู่มือสำนักวิชาวิทยาศาสตร์มีคนเข้ามาดูแล้ว",
    "management-tectnology": "คู่มือสำนักวิชาเทคโนโลยีสังคมมีคนเข้ามาดูแล้ว",
    "management-tectnology-innovation":
      "คู่มือสำนักวิชาเทคโนโลยีสังคมมีคนเข้ามาดูแล้ว",
    "crop-production-technology":
      "คู่มือสำนักวิชาเทคโนโลยีการเกษตรมีคนเข้ามาดูแล้ว",
    "animal-technology-and-innovation":
      "คู่มือสำนักวิชาเทคโนโลยีการเกษตรมีคนเข้ามาดูแล้ว",
    "food-technology": "คู่มือสำนักวิชาเทคโนโลยีการเกษตรมีคนเข้ามาดูแล้ว",
    "manufacturing-automation-and-robotics-engineering":
      "คู่มือสำนักวิชาวิศวกรรมศาสตร์มีคนเข้ามาดูแล้ว",
    "agricultural-and-food-engineering":
      "คู่มือสำนักวิชาวิศวกรรมศาสตร์มีคนเข้ามาดูแล้ว",
    "transportation-and-logistics-engineering":
      "คู่มือสำนักวิชาวิศวกรรมศาสตร์มีคนเข้ามาดูแล้ว",
    "ceramic-engineering": "คู่มือสำนักวิชาวิศวกรรมศาสตร์มีคนเข้ามาดูแล้ว",
    "telecommunication-engineering":
      "คู่มือสำนักวิชาวิศวกรรมศาสตร์มีคนเข้ามาดูแล้ว",
    "polymer-engineering": "คู่มือสำนักวิชาวิศวกรรมศาสตร์มีคนเข้ามาดูแล้ว",
    "polymer-engineering-inter":
      "คู่มือสำนักวิชาวิศวกรรมศาสตร์มีคนเข้ามาดูแล้ว",
    "electrical-engineering": "คู่มือสำนักวิชาวิศวกรรมศาสตร์มีคนเข้ามาดูแล้ว",
    "civil-engineering": "คู่มือสำนักวิชาวิศวกรรมศาสตร์มีคนเข้ามาดูแล้ว",
    "metallurgical-engineering":
      "คู่มือสำนักวิชาวิศวกรรมศาสตร์มีคนเข้ามาดูแล้ว",
    "environmental-engineering":
      "คู่มือสำนักวิชาวิศวกรรมศาสตร์มีคนเข้ามาดูแล้ว",
    "industrial-engineering": "คู่มือสำนักวิชาวิศวกรรมศาสตร์มีคนเข้ามาดูแล้ว",
    "geological-engineering": "คู่มือสำนักวิชาวิศวกรรมศาสตร์มีคนเข้ามาดูแล้ว",
    "geological-engineering-petro":
      "คู่มือสำนักวิชาวิศวกรรมศาสตร์มีคนเข้ามาดูแล้ว",
    "automotive-and-aeronautical-engineering":
      "คู่มือสำนักวิชาวิศวกรรมศาสตร์มีคนเข้ามาดูแล้ว",
    "civil-engineering-inter": "คู่มือสำนักวิชาวิศวกรรมศาสตร์มีคนเข้ามาดูแล้ว",
    "civil-and-infrastructure-engineering":
      "คู่มือสำนักวิชาวิศวกรรมศาสตร์มีคนเข้ามาดูแล้ว",
    "intelligent-embedded-engineering":
      "คู่มือสำนักวิชาวิศวกรรมศาสตร์มีคนเข้ามาดูแล้ว",
    "industrial-electrical-engineering":
      "คู่มือสำนักวิชาวิศวกรรมศาสตร์มีคนเข้ามาดูแล้ว",
    "electronics-and-embedded-system-egineering":
      "คู่มือสำนักวิชาวิศวกรรมศาสตร์มีคนเข้ามาดูแล้ว",
    "electronic-engineering": "คู่มือสำนักวิชาวิศวกรรมศาสตร์มีคนเข้ามาดูแล้ว",
    "computer-engineering": "คู่มือสำนักวิชาวิศวกรรมศาสตร์มีคนเข้ามาดูแล้ว",
    "chemical-engineering": "คู่มือสำนักวิชาวิศวกรรมศาสตร์มีคนเข้ามาดูแล้ว",
    "mechanical-engineering": "คู่มือสำนักวิชาวิศวกรรมศาสตร์มีคนเข้ามาดูแล้ว",
    "material-innovation-and-design-engineering":
      "คู่มือสำนักวิชาวิศวกรรมศาสตร์มีคนเข้ามาดูแล้ว",
    "automotive-engineering": "คู่มือสำนักวิชาวิศวกรรมศาสตร์มีคนเข้ามาดูแล้ว",
    medicine: "คู่มือสำนักวิชาแพทยศาสตร์มีคนเข้ามาดูแล้ว",
    "nursing-science": "คู่มือสำนักวิชาพยาบาลศาสตร์มีคนเข้ามาดูแล้ว",
    "department-dentistry": "คู่มือสำนักวิชาทันตแพทยศาสตร์มีคนเข้ามาดูแล้ว",
    "environmental-health": "คู่มือสำนักวิชาสาธารณสุขศาสตร์มีคนเข้ามาดูแล้ว",
    "occupational-health-and-safety":
      "คู่มือสำนักวิชาสาธารณสุขศาสตร์มีคนเข้ามาดูแล้ว",
    "digital-technology":
      "คู่มือสำนักวิชาศาสตร์และศิลป์ดิจิทัลมีคนเข้ามาดูแล้ว",
    "digital-communication":
      "คู่มือสำนักวิชาศาสตร์และศิลป์ดิจิทัลมีคนเข้ามาดูแล้ว",
    "technology-program-in-innovative-agripreneur":
      "คู่มือสำนักวิชาเทคโนโลยีการเกษตรมีคนเข้ามาดูแล้ว",
    "nutrition-and-dietetics": "คู่มือสำนักวิชาสาธารณสุขศาสตร์มีคนเข้ามาดูแล้ว",
    "nursing-science-60": "คู่มือสำนักวิชาพยาบาลศาสตร์มีคนเข้ามาดูแล้ว",
    "nursing-science-65": "คู่มือสำนักวิชาพยาบาลศาสตร์มีคนเข้ามาดูแล้ว",
    "precision-engineering": "คู่มือสำนักวิชาวิศวกรรมศาสตร์มีคนเข้ามาดูแล้ว",
    "mechatronics-engineering": "คู่มือสำนักวิชาวิศวกรรมศาสตร์มีคนเข้ามาดูแล้ว",
    "mechanical-and-aeronautical-engineering":
      "คู่มือสำนักวิชาวิศวกรรมศาสตร์มีคนเข้ามาดูแล้ว",
    "doctor-of-dental-surgery": "คู่มือสำนักวิชาทันตแพทยศาสตร์มีคนเข้ามาดูแล้ว",
  };

  const listImageContact = {
    "department-science": sci,
    "department-social": soctech,
    "department-agricultural": agri,
    "department-engineering": engi,
    "department-medicine": med,
    "department-nursing": nurs,
    "department-dentistry": dent,
    "department-public-health": pubH,
    "department-degitech": digiT,
  };

  const splitName = (text) => {
    const word = text.split(" ");

    return (
      <>
        {word[0]}
        <br />
        {word[1]}
      </>
    );
  };



  return (
    <>
      <Container>
        <Row>
          <Col span={24}>
            <CusttomBreadcrumb>
              {splitPath.map((item, i) => {
                if (i !== splitPath.length - 1 && i !== 0) {
                  return (
                    <Breadcrumb.Item key={item}>
                      <Link to={newPath(item)}>{breadcrumbName[item]}</Link>
                    </Breadcrumb.Item>
                  );
                } else {
                  return (
                    <Breadcrumb.Item key={item}>
                      <Link to={newPath(item)}> {breadcrumbName[item]}</Link>
                    </Breadcrumb.Item>
                  );
                }
              })}
            </CusttomBreadcrumb>
          </Col>
        </Row>
        <Row>
          <Col span={24}>
            <Title className="animate__animated animate__slideInDown animate__slow">
              {dataBranch?.information?.titleTH}
            </Title>
            <TitleEN className="animate__animated animate__flipInX animate__slow">
              {dataBranch?.information?.titleEN}
            </TitleEN>
          </Col>

          <Col span={24} className="col-left-section">
            <Row gutter={24} className="row-section">
              <Col span={8}>
                {renderLink("name-degree-branch", "ชื่อปริญญาและสาขา")}
                {renderLink("course-structure", "โครงสร้างหลักสูตร")}
                {/* {renderLink(
                  'graduation-goals',
                  'เป้าหมายการรับและการสำเร็จการศึกษา',
                )} */}
              </Col>
              <Col span={8}>
                {renderLink(
                  "vision",
                  splitPath[1] === "department-science"
                    ? "ปรัชญาของหลักสูตร"
                    : "วิสัยทัศน์"
                )}
                {renderLink("study-plan", "แผนการศึกษา")}
                {/* {renderLink('graduation-results', 'ผลการรับและสำเร็จการศึกษา')} */}
              </Col>
              <Col span={8}>
                {renderLink(
                  "mission",
                  splitPath[1] === "department-science"
                    ? "วัตถุประสงค์ของหลักสูตร"
                    : "พันธกิจ"
                )}
                {renderLink("course-teacher", "อาจารย์ประจำหลักสูตร")}
                {/* {renderLink('employment-goals', 'เป้าหมายการได้งานทำของบัณฑิต')} */}
              </Col>
            </Row>
          </Col>
        </Row>
        <Element name="name-degree-branch">
          <Row className="row-branch row-col-branch">
            <Col span={12}>
              <TextTitle>ชื่อปริญญาและสาขา</TextTitle>
              <ListImage>
                {dataBranch?.icon &&
                  dataBranch?.icon.map((item) => {
                    return (
                      item?.detail === "ชื่อหลักสูตร" && (
                        <img src={item?.image} alt="icon name" loading="lazy" />
                      )
                    );
                  })}

                <Row>
                  <Col span={24}>ชื่อหลักสูตร</Col>
                  <Col span={24}>
                    <p>
                      {dataBranch?.information?.nameTH}
                      <br />
                      {dataBranch?.information?.nameEN}
                    </p>
                  </Col>
                </Row>
              </ListImage>

              <ListImage>
                {dataBranch?.icon &&
                  dataBranch?.icon.map((item) => {
                    return (
                      item?.detail === "ชื่อปริญญาบัตรและสาขา" && (
                        <img src={item?.image} alt="icon name" loading="lazy" />
                      )
                    );
                  })}
                <Row>
                  <Col span={24}>ชื่อปริญญาบัตรและสาขา</Col>
                  <Col span={24}>
                    <p>
                      {dataBranch?.information?.nameDegreeTH}
                      <br />
                      {dataBranch?.information?.nameDegreeEN}
                    </p>
                  </Col>
                </Row>
              </ListImage>
            </Col>
            <Col span={11} offset={1}>
              <CustomCarousel autoplay bg={ListColor1[slang]}>
                {dataBranch?.image?.image_0 && (
                  <img
                    loading="lazy"
                    src={dataBranch?.image?.image_0}
                    alt="group"
                    style={{
                      borderRadius: "20px",
                      width: "100%",
                    }}
                  />
                )}

                {dataBranch?.image?.image_1 && (
                  <img
                    loading="lazy"
                    src={dataBranch?.image?.image_1}
                    alt="group"
                    style={{
                      borderRadius: "20px",
                      width: "100%",
                    }}
                  />
                )}

                {dataBranch?.image?.image_2 && (
                  <img
                    loading="lazy"
                    src={dataBranch?.image?.image_2}
                    alt="group"
                    style={{
                      borderRadius: "20px",
                      width: "100%",
                    }}
                  />
                )}
              </CustomCarousel>
            </Col>
          </Row>
        </Element>

        <Row className="row-branch row-col-branch">
          <Col span={12}>
            <Element name="vision">
              <TextTitle>{ splitPath[1] === "department-science"
                    ? "ปรัชญาของหลักสูตร"
                    : "วิสัยทัศน์"}</TextTitle>
              <TextDetail>
                {dataBranch?.vision?.vision_0 && (
                  <>
                    {dataBranch?.vision?.vision_0}
                    <br />
                  </>
                )}
                {dataBranch?.vision?.vision_1 && (
                  <>
                    {dataBranch?.vision?.vision_1}
                    <br />
                  </>
                )}
                {dataBranch?.vision?.vision_2 && (
                  <>
                    {dataBranch?.vision?.vision_2}
                    <br />
                  </>
                )}
                {dataBranch?.vision?.vision_3 && (
                  <>
                    {dataBranch?.vision?.vision_3}
                    <br />
                  </>
                )}
                {dataBranch?.vision?.vision_4 && (
                  <>
                    {dataBranch?.vision?.vision_4}
                    <br />
                  </>
                )}
                {dataBranch?.vision?.vision_5 && (
                  <>
                    {dataBranch?.vision?.vision_5}
                    <br />
                  </>
                )}
                {dataBranch?.vision?.vision_6 && (
                  <>
                    {dataBranch?.vision?.vision_6}
                    <br />
                  </>
                )}
                {dataBranch?.vision?.vision_7 && (
                  <>
                    {dataBranch?.vision?.vision_7}
                    <br />
                  </>
                )}
                {dataBranch?.vision?.vision_8 && (
                  <>
                    {dataBranch?.vision?.vision_8}
                    <br />
                  </>
                )}
                {dataBranch?.vision?.vision_9 && (
                  <>
                    {dataBranch?.vision?.vision_9}
                    <br />
                  </>
                )}
                {dataBranch?.vision?.vision_10 && (
                  <>
                    {dataBranch?.vision?.vision_10}
                    <br />
                  </>
                )}
              </TextDetail>
            </Element>
          </Col>
          <Col span={11} offset={1}>
            <Element name="mission">
              <TextTitle>{splitPath[1] === "department-science"
                    ? "วัตถุประสงค์ของหลักสูตร"
                    : "พันธกิจ"}</TextTitle>
              <TextDetail>
                {dataBranch?.mission?.mission_0 && (
                  <>
                    {dataBranch?.mission?.mission_0}
                    <br />
                  </>
                )}

                {dataBranch?.mission?.mission_1 && (
                  <>
                    {dataBranch?.mission?.mission_1}
                    <br />
                  </>
                )}
                {dataBranch?.mission?.mission_2 && (
                  <>
                    {dataBranch?.mission?.mission_2}
                    <br />
                  </>
                )}
                {dataBranch?.mission?.mission_3 && (
                  <>
                    {dataBranch?.mission?.mission_3}
                    <br />
                  </>
                )}
                {dataBranch?.mission?.mission_4 && (
                  <>
                    {dataBranch?.mission?.mission_4}
                    <br />
                  </>
                )}
                {dataBranch?.mission?.mission_5 && (
                  <>
                    {dataBranch?.mission?.mission_5}
                    <br />
                  </>
                )}
                {dataBranch?.mission?.mission_6 && (
                  <>
                    {dataBranch?.mission?.mission_6}
                    <br />
                  </>
                )}
                {dataBranch?.mission?.mission_7 && (
                  <>
                    {dataBranch?.mission?.mission_7}
                    <br />
                  </>
                )}
                {dataBranch?.mission?.mission_8 && (
                  <>
                    {dataBranch?.mission?.mission_8}
                    <br />
                  </>
                )}
                {dataBranch?.mission?.mission_9 && (
                  <>
                    {dataBranch?.mission?.mission_9}
                    <br />
                  </>
                )}
                {dataBranch?.mission?.mission_10 && (
                  <>
                    {dataBranch?.mission?.mission_10}
                    <br />
                  </>
                )}
              </TextDetail>
            </Element>
          </Col>
        </Row>

        <Row className="row-branch">
          <Row
            gutter={[24, 50]}
            className="row-structure col-left-section"
            style={{ width: "100%" }}
          >
            {dataBranch?.icon &&
              dataBranch?.icon.map((item, index) => {
                return (
                  item?.detail !== "ชื่อปริญญาบัตรและสาขา" &&
                  item?.detail !== "ชื่อหลักสูตร" &&
                  item?.detail !== "ผลการรับและ สำเร็จการศึกษา" &&
                  item?.detail !== "เป้าหมายการได้งานทำ ของบัณฑิต" &&
                  item?.detail !== "เป้าหมายการรับและ การสำเร็จการศึกษา" && (
                    <Col span={8} key={index}>
                      <Element name={runderElement[item?.detail]}>
                        <TextTitle height="60" center="center">
                          {splitName(item?.detail)}
                        </TextTitle>
                        <BoxImage>
                          <div className="icon-course-structure">
                            <img
                              loading="lazy"
                              src={item?.image}
                              alt="icon pencil blue"
                              style={{
                                width: "250px",
                                height: "250px",
                                padding: "10px",
                              }}
                            />
                          </div>

                          {/* {item?.detail && LinkBranch(item?.detail)} */}

                          {item?.detail && (
                            <a
                              href={renderLinkName[item?.detail]}
                              target="_blank"
                              rel="noreferrer"
                              download
                            >
                              <div
                                style={{
                                  width: "100%",
                                  display: "flex",
                                  justifyContent: "center",
                                }}
                              >
                                <p>อ่านเพิ่มเติม</p>
                              </div>
                            </a>
                          )}
                        </BoxImage>
                      </Element>
                    </Col>
                  )
                );
              })}
          </Row>
        </Row>

        {dataBranch?.footer && (
          <FixBoxLayout>
            <Row>
              <Col span={8}>
                <img
                  loading="lazy"
                  src={dataBranch?.footer?.image_0}
                  alt="branch"
                  style={{ width: "100%" }}
                />
              </Col>
              <Col span={8}>
                <img
                  loading="lazy"
                  src={dataBranch?.footer?.image_1}
                  alt="branch"
                  style={{ width: "100%" }}
                />
              </Col>

              <Col span={8}>
                <img
                  loading="lazy"
                  src={dataBranch?.footer?.image_2}
                  alt="branch"
                  style={{ width: "100%" }}
                />
              </Col>
            </Row>
          </FixBoxLayout>
        )}

        {contactData && (
          <>
            <div
              style={{
                marginTop: "10%",
              }}
            >
              <TextTitle center="center"> {ListContact[slang]}</TextTitle>
            </div>

            <Row
              gutter={24}
              style={{ marginTop: "50px" }}
              className="row-branch-contact"
            >
              <Col span={8}>
                <CardContact background={ListColor1[slang]}>
                  <div className="container">
                    <DetailContact
                      color={`${
                        slang === "physics" ||
                        slang === "chemical" ||
                        slang === "sports-science" ||
                        slang === "mathematics" ||
                        slang === "geographical-informatics" ||
                        slang === "biology"
                          ? "var(--black)"
                          : "white"
                      }`}
                      title={contactData[0]?.title}
                      phone={contactData[0]?.phone_1}
                      office={contactData[0]?.phone_2}
                      facebook={contactData[0]?.fb}
                      website={contactData[0]?.site}
                      email1={contactData[0]?.email_1}
                      email2={contactData[0]?.email_2}
                      email3={contactData[0]?.email_3}
                      line={contactData[0]?.line}
                      type="department"
                      indent="40"
                    />
                  </div>

                  {contactData && (
                    <img
                      loading="lazy"
                      src={
                        contactData[0]?.image
                          ? contactData[0]?.image
                          : listImageContact[slang]
                      }
                      alt="icon rectangle"
                      style={{
                        borderRadius: "20px",
                        width: "100%",
                        marginTop: "20px",
                      }}
                    />
                  )}
                </CardContact>
              </Col>

              <Col span={15} offset={1}>
                <Row gutter={24}>
                  {contactData &&
                    contactData.slice(1).map((item, index) => {
                      return (
                        <Col span={12} style={{ padding: "10px" }} key={index}>
                          <div style={styleDetailContact}>
                            <DetailContact
                              color="var(--black)"
                              title={item?.title}
                              phone={item?.phone_1}
                              office={item?.phone_2}
                              facebook={item?.fb}
                              website={item?.site}
                              email1={item?.email_1}
                              email2={item?.email_2}
                              email3={item?.email_3}
                              line={item?.line}
                              type="branch"
                              indent={
                                slang === "doctor-of-dental-surgery"
                                  ? "0"
                                  : "40"
                              }
                              slang={slang}
                            />
                          </div>
                        </Col>
                      );
                    })}
                </Row>
              </Col>
            </Row>
          </>
        )}

        <FixBoxLayout bg={ListColor2[slang]}>
          <div className="layout-view">
            <Row className="row-group" style={{ alignItems: "center" }}>
              <Col span={8}>
                <img
                  loading="lazy"
                  src={stuView}
                  style={{ width: "100%", maxWidth: "460px" }}
                  alt="student view"
                />
              </Col>
              <Col span={16}>
                <div style={{ maxwWidth: "450px" }}>
                  <SubHead align="center">{ListView[slang]}</SubHead>
                  <View>
                    <CountUp
                      start={0}
                      end={dataBranch?.visitor ? dataBranch?.visitor : 0}
                      duration={2}
                      useEasing={true}
                      useGrouping={true}
                      separator=","
                      decimals={0}
                      decimal=","
                    />
                  </View>
                  <SubHead align="center">ครั้ง</SubHead>
                </div>
              </Col>
            </Row>
          </div>
        </FixBoxLayout>
      </Container>
      <ScrollUpBtn />
    </>
  );
};

export default CourseInfoBranch;
